import React, { useEffect, useState } from "react";
import "./Hero.css";

const Hero = ({ title, subtitle }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "/hero.png";
    img.onload = () => setIsLoaded(true);
  }, []);

  return (
    <section className={`hero ${isLoaded ? "loaded" : ""}`}>
      <div className="container">
        <div className="hero-content">
          <div className="hero-logo">
            <img src="/logo.png" alt="🍵" loading="lazy" />
          </div>
          <h1 className="hero-title">{title}</h1>
          <p className="hero-subtitle">{subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
